<template>
  <div v-for="notification in notifications" :class="{ notification: true, high: notification.level == 'high', medium: notification.level == 'medium', low: notification.level == 'low' }">
    <img v-if="notification.level == 'high'" src="../assets/alert.svg" alt="" />
    <img v-if="notification.level == 'medium'" src="../assets/info.svg" alt="" />
    <p v-if="notification.message == '$$OOO'">
      You are currently set to out of office. <span @click="$router.push({ name: 'user-profile' })" style="cursor: pointer; text-decoration: underline">Click here to turn it off</span>.
    </p>
    <p v-else>{{ notification.message }}</p>
    <div @click="removeNotification(notification.id)" class="close-btn">
      <img src="../assets/close-small.svg" alt="" />
    </div>
  </div>
</template>

<script>
import useNotifications from '@/composables/useNotifications';

export default {
  name: 'Alert',
  setup() {
    const { notifications, removeNotification } = useNotifications();

    return {
      notifications,
      removeNotification,
    };
  },
};
</script>

<style lang="scss" scoped>
.notification {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0;
  width: 100vw;

  img {
    width: 1.5rem;
    height: 1.1rem;
    margin-left: 1.5rem;
  }

  p {
    color: white;
    margin: 0;
    margin-left: 0.2rem;
    flex: 1;
    padding: 0.85rem;
    font-size: $fontSize13;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .close-btn {
    cursor: pointer;
    display: flex;
    align-items: center;
    height: 2.1rem;
    img {
      width: 0.9rem;
      height: 0.9rem;
      margin-right: 1.5rem;
    }
  }
}

.high {
  background-color: $alertColor;

  .close-btn {
    border-left: 1px solid #ea3939;
  }
}

.medium {
  background-color: $alertBlueColor;

  .close-btn {
    border-left: 1px solid #3687e9;
  }
}

.low {
  background-color: $darkGrayColor;

  .close-btn {
    border-left: 1px solid #6c6c6c;
  }

  p {
    margin-left: 1.5rem;
  }
}
</style>
